import { render, staticRenderFns } from "./audio2.vue?vue&type=template&id=5834f347&scoped=true"
import script from "./audio2.vue?vue&type=script&lang=js"
export * from "./audio2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834f347",
  null
  
)

export default component.exports